























import Vue from 'vue'
import ActiveMountBlock from './_ActiveMountBlock.vue'
import ActiveSystemsBlock from './_ActiveSystemsBlock.vue'

export default Vue.extend({
  name: 'active-mech-loadout-block',
  components: { ActiveSystemsBlock, ActiveMountBlock },
  props: {
    mech: {
      type: Object,
      required: true,
    },
    rest: {
      type: Boolean,
    },
  },
  computed: {
    color() {
      return this.mech.Frame.Manufacturer.GetColor(this.$vuetify.theme.dark)
    },
  },
})
